import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { IntegrationsService } from "@app/modules/site-settings-integrations/services/integrations.service";
import moment from 'moment';
import { IntegrationEventVerbose } from '@app/modules/site-settings-integrations/models/integrations.model';

@Component({
    selector: 'app-integration-logs-dialog',
    templateUrl: './integration-logs-dialog.component.html',
    styleUrls: ['./integration-logs-dialog.component.scss']
})
export class IntegrationLogsDialogComponent implements OnInit {

    integrationEvent: any;
    integrationEventVerbose: IntegrationEventVerbose;
    isLoading: boolean = false;
    payload: any;
    mergedMessages: string = '';

    constructor(
        private dialogRef: MatDialogRef<IntegrationLogsDialogComponent>,
        private integrationService: IntegrationsService,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.integrationEvent = data.integrationEvent;
    }

    ngOnInit() {
        this.getData();
    }

    confirm() {
        this.dialogRef.close(true);
    }

    close() {
        this.dialogRef.close();
    }

    getPrettyJson(payload: any) {
        let prettyJson = '';

        try {
            prettyJson = JSON.parse(payload);
        } catch (error) {
            return payload;
        }

        return JSON.stringify(prettyJson, null, 2);
    }

    mergeMessages(data: any[]): string {
        const sortedData = data.sort((a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime());
        return sortedData.map(item => {
            const timestamp = moment(item.createdOn).format('YYYY-MM-DD HH:mm:ss');
            return `${timestamp}: ${item.message}`;
        }).join('\n\n');
    }

    getData() {
        this.isLoading = true;

        this.integrationService.getIntegrationEvent(this.integrationEvent.id)
        .pipe(
            finalize(() => {
                this.isLoading = false;
            })
        )
        .subscribe(res => {
            this.integrationEventVerbose = res;
            this.mergedMessages = this.mergeMessages(res.logs);
        })
    }
}
